import { useCallback } from 'react';
import { IdentityGroupAri, IdentityUserAri } from '@atlassian/ari';
import { useService } from '../utils';
import { UserAccountType } from './types';
const PRINCIPAL_PICKER_LIMIT = 50;
export const useSearchUsersAndGroups = () => {
  var _data$users$users$fil, _data$groups$groups$m;
  const request = useCallback(async query => {
    const queryParams = new URLSearchParams({
      query,
      maxResults: PRINCIPAL_PICKER_LIMIT.toString(),
      showAvatar: 'true',
      avatarSize: 'medium',
      caseInsensitive: 'true'
    });
    const response = await fetch(`/rest/api/3/groupuserpicker?${queryParams.toString()}`, {
      credentials: 'same-origin'
    });
    if (response.ok) {
      return response.json();
    }
    throw new Error(`Unexpected response from ${response.url} ${response.status} ${response.statusText}`);
  }, []);
  const {
    data,
    loading,
    error,
    fetch: searchUsersAndGroups
  } = useService(request);
  const userOptions = (_data$users$users$fil = data === null || data === void 0 ? void 0 : data.users.users.filter(({
    accountType
  }) => accountType !== UserAccountType.CUSTOMER) // Customer account not supported yet.
  .map(user => ({
    id: IdentityUserAri.create({
      userId: user.accountId
    }).toString(),
    name: user.displayName,
    type: 'user',
    avatarUrl: user.avatarUrl
  }))) !== null && _data$users$users$fil !== void 0 ? _data$users$users$fil : [];
  const groupOptions = (_data$groups$groups$m = data === null || data === void 0 ? void 0 : data.groups.groups.map(group => ({
    id: IdentityGroupAri.create({
      groupId: group.groupId
    }).toString(),
    name: group.name,
    type: 'group'
  }))) !== null && _data$groups$groups$m !== void 0 ? _data$groups$groups$m : [];
  const options = userOptions.concat(groupOptions).sort((a, b) => a.name.localeCompare(b.name));
  return {
    data: options,
    loading,
    error,
    searchUsersAndGroups
  };
};